export function generateExerciseImageUrl(exerciseName: string): string {
  const query = exerciseName.toLowerCase().replace(/\s+/g, "-");
  return `https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=400&h=300&fit=crop&q=80&auto=format&bg=black&fm=jpg&s=${query}`;
}

export function getVideoThumbnailUrl(videoUrl?: string | null): string | null {
  const url = videoUrl?.trim();
  if (!url) return null;

  // YouTube: watch?v=, youtu.be/, or /embed/
  const yt = /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([\w-]+)/i.exec(url);
  if (yt?.[1]) return `https://img.youtube.com/vi/${yt[1]}/hqdefault.jpg`;

  // Vimeo: vimeo.com/<id> or player.vimeo.com/video/<id>
  const vm = /vimeo\.com\/(\d+)/i.exec(url) ?? /player\.vimeo\.com\/video\/(\d+)/i.exec(url);
  if (vm?.[1]) return `https://vumbnail.com/${vm[1]}.jpg`;

  return null;
}

export function getVideoEmbedUrl(videoUrl?: string | null): string | null {
  const url = videoUrl?.trim();
  if (!url) return null;

  // YouTube: watch?v=, youtu.be/, or /embed/
  const yt = /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([\w-]+)/i.exec(url);
  if (yt?.[1]) return `https://www.youtube.com/embed/${yt[1]}`;

  // Vimeo: vimeo.com/<id> or player.vimeo.com/video/<id>
  const vm = /vimeo\.com\/(\d+)/i.exec(url) ?? /player\.vimeo\.com\/video\/(\d+)/i.exec(url);
  if (vm?.[1]) return `https://player.vimeo.com/video/${vm[1]}`;

  return null;
}

export function getExerciseCardImageSrc(exercise: {
  name: string;
  image_url?: string | null;
  video_url?: string | null;
}): string {
  return exercise.image_url || getVideoThumbnailUrl(exercise.video_url) || generateExerciseImageUrl(exercise.name);
}

